<template>
    <div class="pageDiv">
        <v-card class="main-card" v-if="$AuthSvc.isLogin()">
            <v-card-title style="padding-bottom:0">
                <span class="page-title">{{$AuthSvc.getYear()}} Championship Standings</span>
            </v-card-title>

            <div v-if="nicklaus.length > 0">
                <v-simple-table class="leader-table">
                    <tr>
                        <th width="10px">#</th>
                        <th >Nicklaus</th>
                        <th width="10px">T1</th>
                        <th width="10px">T2</th>
                        <th width="10px">T3</th>
                        <th width="60px">Total</th>
                    </tr>
                    <tr v-for="(leader, index) in nicklaus"  :key="leader.playerId">
                        <td :class="{texasCup: index < 22, challengeCup: index >= 22 && index < 44}">{{index+1}}</td>
                        <td :class="{texasCup: index < 22, challengeCup: index >= 22 && index < 44}">
                            {{leader.firstName}}
                            {{$AuthSvc.firstChar(leader.middleName)}}
                            {{leader.lastName}}</td>
                        <td>{{leader.score1===0?'':leader.score1}}</td>
                        <td>{{leader.score2===0?'':leader.score2}}</td>
                        <td>{{leader.score3===0?'':leader.score3}}</td>
                        <td :class="{texasCup: index < 22, challengeCup: index >= 22 && index < 44}">{{leader.total===1000?"0":leader.total}}</td>
                    </tr>
                </v-simple-table>
            </div>

            <div v-if="palmer.length > 0">
                <v-simple-table class="leader-table">
                    <tr>
                        <th width="10px">#</th>
                        <th >Palmer</th>
                        <th width="10px">T1</th>
                        <th width="10px">T2</th>
                        <th width="10px">T3</th>
                        <th width="60px">Total</th>
                    </tr>
                    <tr v-for="(leader, index) in palmer"  :key="leader.playerId">
                        <td :class="{texasCup: index < 22, challengeCup: index >= 22 && index < 44}">{{index+1}}</td>
                        <td :class="{texasCup: index < 22, challengeCup: index >= 22 && index < 44}">
                            {{leader.firstName}}
                            {{$AuthSvc.firstChar(leader.middleName)}}
                            {{leader.lastName}}</td>
                        <td>{{leader.score1===0?'':leader.score1}}</td>
                        <td>{{leader.score2===0?'':leader.score2}}</td>
                        <td>{{leader.score3===0?'':leader.score3}}</td>
                        <td :class="{texasCup: index < 22, challengeCup: index >= 22 && index < 44}">{{leader.total===1000?"0":leader.total}}</td>
                    </tr>
                </v-simple-table>
            </div>

            <div v-if="hogan.length > 0">
                <v-simple-table class="leader-table">
                    <tr>
                        <th width="10px">#</th>
                        <th >Hogan</th>
                        <th width="10px">T1</th>
                        <th width="10px">T2</th>
                        <th width="10px">T3</th>
                        <th width="60px">Total</th>
                    </tr>
                    <tr v-for="(leader, index) in hogan"  :key="leader.playerId">
                        <td :class="{texasCup: index < 22, challengeCup: index >= 22 && index < 44}">{{index+1}}</td>
                        <td :class="{texasCup: index < 22, challengeCup: index >= 22 && index < 44}">
                            {{leader.firstName}}
                            {{$AuthSvc.firstChar(leader.middleName)}}
                            {{leader.lastName}}</td>
                        <td>{{leader.score1===0?'':leader.score1}}</td>
                        <td>{{leader.score2===0?'':leader.score2}}</td>
                        <td>{{leader.score3===0?'':leader.score3}}</td>
                        <td :class="{texasCup: index < 22, challengeCup: index >= 22 && index < 44}">{{leader.total===1000?"0":leader.total}}</td>
                    </tr>
                </v-simple-table>
            </div>

            <div v-if="women.length > 0">
                <v-simple-table class="leader-table">
                    <tr>
                        <th width="10px">#</th>
                        <th >Women</th>
                        <th width="10px">T1</th>
                        <th width="10px">T2</th>
                        <th width="10px">T3</th>
                        <th width="60px">Total</th>
                    </tr>
                    <tr v-for="(leader, index) in women"  :key="leader.playerId">
                        <td :class="{texasCup: index < 22, challengeCup: index >= 22 && index < 44}">{{index+1}}</td>
                        <td :class="{texasCup: index < 22, challengeCup: index >= 22 && index < 44}">
                            {{leader.firstName}}
                            {{$AuthSvc.firstChar(leader.middleName)}}
                            {{leader.lastName}}</td>
                        <td>{{leader.score1===0?'':leader.score1}}</td>
                        <td>{{leader.score2===0?'':leader.score2}}</td>
                        <td>{{leader.score3===0?'':leader.score3}}</td>
                        <td :class="{texasCup: index < 22, challengeCup: index >= 22 && index < 44}">{{leader.total===1000?"0":leader.total}}</td>
                    </tr>
                </v-simple-table>
            </div>
        </v-card>
    </div>
</template>

<script>
  export default {
    name: "login",
    data: () => ({
      count: 0,
      nicklaus: [],
      palmer: [],
      hogan: [],
      women: []
    }),
    mounted: function() {
        var _this = this;

        this.axios.get('/api/tournaments/championship/leaders')
        .then(function (response) {
             var i;
             for (i=0; i < response.data.length; i++) {
               if (response.data[i].flight === 'Nicklaus') {
                _this.nicklaus.push(response.data[i]);
               }
               else if (response.data[i].flight === 'Palmer') {
                _this.palmer.push(response.data[i]);
               }
               else if (response.data[i].flight === 'Hogan') {
                _this.hogan.push(response.data[i]);
               }
               else if (response.data[i].flight === 'Women') {
                _this.women.push(response.data[i]);
               }
             }
        })
        .catch(function (error) {
            console.log('ERROR: ' + error);
        });
    },
    methods: {
      incrementCount: function() {
        this.count++;
        return this.count;
      }
    }
  }

</script>

<style scoped>

  .main-card {
    height: 1600px !important;
  }

  .leader-table {
    margin-top: 20px;
  }

  @media (min-width: 768px) {
      td {
        font-size: 12px !important;
      }

      .main-card {
        height: 1400px;
        vertical-align: top;
      }

      .leader-table {
        display: inline-block;
        float: left;
        margin: 10px;
        width: 400px;
        vertical-align: top;
      }
  }

  th {
      text-align: left;
      height: 28px;
      background-color: #45472e;
      border:1px solid aquamarine;
      box-shadow:2px 2px 1px -1px #000;
      font-size: 16px;
      color: aquamarine;
  }

  th, td {
      padding: 5px 10px;
  }

  td {
      font-size: 18px;
      color: #2a2b1e;
      border:1px solid rgba(0,0,0,0.4);
      box-shadow:-1px -1px 1px -1px #000;
  }

</style>